module.exports = __webpack_public_path__ + "img/aej1n-66wvl.007.052473f0.png";